import React from "react";
import { CustomPicker } from "react-color";
import { Hue, Saturation, EditableInput, Alpha } from "react-color/lib/components/common";
import { rgbToString } from "../helpers";

function ColorPicker(props) {

	const { allowAlpha = false } = props;

	return <div className="colorPicker">
		<div className="hue">
			<Hue {...props} />
		</div>
		{allowAlpha && <div className="alpha">
			<Alpha {...props} />
		</div>}
		<div className="flexy">
			<div className="saturation">
				<Saturation {...props} />
			</div>
			<div
				className="sample"
				style={{
					backgroundColor: allowAlpha ? rgbToString(props.rgb) : props.hex,
					flex: 0.5
				}}
			/>
		</div>
		<div className="manual">
			<EditableInput
				{...props}
				value={props.hex}
				style={{
					padding: 5
				}}
			/>
		</div>
	</div>
}

export default CustomPicker(ColorPicker);